import React, { useState, useEffect, useRef } from 'react';

import { isElementOverFlowing } from '../../utils';
import Tooltip from '../Tooltip/Tooltip';

const LabelWithTooltip = ({ name, tooltipContent, forceTooltip }) => {
  const nameRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (nameRef.current) {
      setIsOverflowing(isElementOverFlowing(nameRef.current));
    }
  }, [name]);

  return (
    <Tooltip
      content={tooltipContent || name}
      disabled={!forceTooltip && !isOverflowing}
    >
      <div
        className="ellipsed-text"
        ref={nameRef}
      >
        {name}
      </div>
    </Tooltip>
  );
};

export default LabelWithTooltip;
